import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { X as XIcon } from "lucide-react";

export default function ClearFilterButton() {
  const { clearAll, isAnyFilterApplied } = useReturnRequestsFilters();
  const t = useTranslation();
  if (!isAnyFilterApplied) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className="ml-auto hidden h-8 lg:flex"
      onClick={() => {
        clearAll();
      }}
    >
      <XIcon className="mr-2 h-4 w-4" />
      {t("misc.clear")}
    </Button>
  );
}
